import { ChatMessage as ChatMessageType } from 'interfaces/chat.interface'

type UserMessageProps = {
  message: ChatMessageType | string
  showTimestamp?: boolean
}

const UserMessage: React.FC<UserMessageProps> = ({
  message,
  showTimestamp = false,
}) => {
  const messageText = typeof message === 'string' ? message : message.content
  const timestamp = typeof message === 'string' ? null : message.timestamp

  return (
    <div className="w-full flex flex-col justify-end items-end mb-4 animate-fade-in">
      <div className="max-w-[70%] bg-background rounded-md p-3 transition-all duration-300 ease-in-out">
        <div className="text-xs font-normal leading-4 text-text-heading">{messageText}</div>
      </div>
      {showTimestamp && timestamp && (
        <div className="text-[10px] mt-1 text-text-muted font-semibold opacity-75">
          {(() => {
            const date = new Date(timestamp)
            return date.toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            }).toLowerCase()
          })()}
        </div>
      )}
    </div>
  )
}

export default UserMessage
